/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Edit_Restore_TitleInputs */



/**
* | output |
* | --- |
* | "Edit and restore?" |
*
* @param {Assistant_Edit_Restore_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_edit_restore_title = /** @type {((inputs?: Assistant_Edit_Restore_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Edit_Restore_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier et restaurer ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeiten und wiederherstellen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modificare e ripristinare?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать и восстанавливать?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Editar y restaurar?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑和恢复？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("編集して復元しますか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादित करें और पुनर्स्थापित करें?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar e restaurar?")
	return /** @type {LocalizedString} */ ("Edit and restore?")
});